import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ReportDownload from './components/ReportDownload';
import FundOverview from './components/FundOverview';
import DistributionRecords from './components/DistributionRecords';
import DonorList from './components/DonorList';

export default function TransparencyPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <Navbar />
      
      {/* 页面标题 - 添加pt-16避免被导航遮挡 */}
      <div className="bg-gradient-to-br from-[#2A7A62] to-[#2A7A62]/80 text-white pt-20 md:pt-24 pb-8 md:pb-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-4">
            <i className="ri-shield-check-line text-2xl md:text-4xl"></i>
            <h1 className="text-2xl md:text-4xl font-bold">公益公示</h1>
          </div>
          <p className="text-xs md:text-lg text-white/90 max-w-3xl">
            透明是公益的生命线。我们承诺公开每一笔善款的来源与去向，接受社会各界监督，确保每一分爱心都用在实处。
          </p>
          <div className="flex items-center gap-3 md:gap-6 mt-3 md:mt-6 text-[10px] md:text-sm">
            <div className="flex items-center gap-1 md:gap-2">
              <i className="ri-checkbox-circle-line text-base md:text-xl"></i>
              <span>财务公开</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2">
              <i className="ri-checkbox-circle-line text-base md:text-xl"></i>
              <span>第三方审计</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2">
              <i className="ri-checkbox-circle-line text-base md:text-xl"></i>
              <span>实时更新</span>
            </div>
          </div>
        </div>
      </div>

      {/* 主要内容 */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-12 space-y-4 md:space-y-8">
        {/* 报告下载中心 */}
        <ReportDownload />

        {/* 资金使用总览 */}
        <FundOverview />

        {/* 发放记录查询 */}
        <DistributionRecords />

        {/* 捐赠名录 */}
        <DonorList />

        {/* 监督与反馈 */}
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-bold text-[#1E1E1E] mb-4 md:mb-6">监督与反馈</h2>
          <div className="grid grid-cols-3 gap-3 md:gap-6">
            <div className="p-3 md:p-6 bg-[#F9F9F9] rounded-lg text-center">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#2A7A62] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-phone-line text-xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-[#1E1E1E] mb-1 md:mb-2">监督热线</h3>
              <p className="text-[#2A7A62] font-bold text-[10px] md:text-xl mb-1 md:mb-2">023-6288-8888</p>
              <p className="text-[9px] md:text-sm text-[#6C6C6C]">工作日 9:00-18:00</p>
            </div>

            <div className="p-3 md:p-6 bg-[#F9F9F9] rounded-lg text-center">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#2A7A62] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-mail-line text-xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-[#1E1E1E] mb-1 md:mb-2">监督邮箱</h3>
              <p className="text-[#2A7A62] font-bold text-[9px] md:text-lg mb-1 md:mb-2 break-all">jiandu@didiplan.org</p>
              <p className="text-[9px] md:text-sm text-[#6C6C6C]">24小时接收反馈</p>
            </div>

            <div className="p-3 md:p-6 bg-[#F9F9F9] rounded-lg text-center">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#2A7A62] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className="ri-wechat-line text-xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-[#1E1E1E] mb-1 md:mb-2">微信公众号</h3>
              <p className="text-[#2A7A62] font-bold text-[8px] md:text-sm mb-1 md:mb-2 leading-tight">重庆市南岸区<br className="md:hidden" />明明德志愿服务中心</p>
              <p className="text-[9px] md:text-sm text-[#6C6C6C]">在线咨询与投诉</p>
            </div>
          </div>

          <div className="mt-4 md:mt-8 p-3 md:p-6 bg-gradient-to-br from-[#F4B942]/10 to-[#F4B942]/5 rounded-lg border-l-4 border-[#F4B942]">
            <div className="flex items-start gap-2 md:gap-3">
              <i className="ri-information-line text-base md:text-2xl text-[#F4B942] mt-0.5 md:mt-1"></i>
              <div>
                <p className="text-xs md:text-base font-bold text-[#1E1E1E] mb-1 md:mb-2">投诉与建议</p>
                <p className="text-[10px] md:text-sm text-[#6C6C6C] leading-relaxed">
                  如您发现任何违规行为或有改进建议，欢迎通过以上渠道联系我们。我们承诺在3个工作日内回复，并对所有反馈进行认真调查处理。您的监督是我们进步的动力。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
